import {
  Component,
  input,
  output,
  OnInit,
  signal,
  computed,
  inject,
  ChangeDetectorRef,
} from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
  CdkDragDrop,
  DragDropModule,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { QUESTION_TYPE_CONFIG } from '@hyper-inferno/skip-logic-core';
import { ConditionRulesManagerService } from './condition-rule-manager-service/condition-rules-manager.service';
import { SurveyBuilderService } from '../survey-builder/survey-builder.service';
import {
  LucideAngularModule,
  Plus,
  Trash2,
  GripVertical,
} from 'lucide-angular';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import {
  ConditionSetElementType,
  Condition,
  ConditionSet,
  OPERATORS,
  QuestionType,
  Element,
} from '@hyper-inferno/survey-elements-core';
import { DataStoreService } from '../data-store-service/data-store.service';
import { ConditionRuleBuilder } from '../condition-rule-builder/condition-rule-builder';
@Component({
  selector: 'app-condition-rule-manager',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DragDropModule,
    LucideAngularModule,
    ConditionRuleBuilder,
  ],
  templateUrl: './condition-rule-manager.component.html',
  styleUrl: './condition-rule-manager.component.css',
})
export class ConditionRuleManagerComponent {
  // Signal Inputs
  parentId = input<any>();
  parentType = input.required<ConditionSetElementType>();
  conditionSetId = input<string | null>();
  conditionSetReady = output<string>();
  isLoading = signal(false);
}
